module.exports = __webpack_public_path__ + "img/icon@2x(2).265a09fa.png";